module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "cambiar-password-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.oldpass),
      expression: "form.oldpass"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5'),
      expression: "'required|min:5'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "signin_oldpass",
      "name": "oldpass",
      "type": "password",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('oldpasswordPlaceholder')
    },
    domProps: {
      "value": (_vm.form.oldpass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "oldpass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('oldpass')),
      expression: "errors.has('oldpass')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('passValidation')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pass),
      expression: "form.pass"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5'),
      expression: "'required|min:5'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "signin_pass",
      "name": "pass",
      "type": "password",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('passwordPlaceholder')
    },
    domProps: {
      "value": (_vm.form.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pass')),
      expression: "errors.has('pass')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('passValidation')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.confirmpass),
      expression: "form.confirmpass"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|confirmed:pass'),
      expression: "'required|min:5|confirmed:pass'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "signin_confirm_pass",
      "name": "confirmpass",
      "type": "password",
      "data-vv-delay": "500",
      "placeholder": _vm.$t('cofirmPsswPlaceholder')
    },
    domProps: {
      "value": (_vm.form.confirmpass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmpass", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmpass')),
      expression: "errors.has('confirmpass')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('passEqualValidation')))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('cambiarClau')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58c8b2a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/cambiar-password-modal/cambiar-password-modal.vue
// module id = 310
// module chunks = 0